import { MintStatus } from "@/modules/kreate-components/components/Select$MintStatus";

type UrlQueryCodec<T> = {
  name: string;
  toValue: (text: string) => T;
  fromValue: (value: T) => string;
};

const mintStatus: UrlQueryCodec<MintStatus> = {
  name: "ms",
  fromValue: (value) => {
    switch (value) {
      case "available_for_minting":
        return "afm";
      case "sold_out":
        return "so";
      default:
        return "";
    }
  },
  toValue: (text) => {
    switch (text) {
      case "afm":
        return "available_for_minting";
      case "so":
        return "sold_out";
      default:
        return "all";
    }
  },
};

const isSingleEdition: UrlQueryCodec<boolean> = {
  name: "nft",
  fromValue: (value) => {
    switch (value) {
      case true:
        return "1";
      default:
        return "";
    }
  },
  toValue: (text) => {
    switch (text) {
      case "1":
        return true;
      default:
        return false;
    }
  },
};

export const urlQueryCodecs = {
  mintStatus,
  isSingleEdition,
};
